// extracted by mini-css-extract-plugin
module.exports = {"reelBtn":"reel-footer_reelBtn__LF5_A"};